<template>
  <div class="user_gallery_list_wrap">
    <div class="user_gallery_list_box" v-for="i in 3" :key="i" @click="movePage('/gallery')">
      <div class="user_gallery_list_img"></div>
      <div class="user_gallery_list_title">
        <span>고양이 사진관</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemListGalleryUserLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    movePage(url){
      this.$router.push(url);
    }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>